<div class="utilization-widget" *ngIf="utilization">
  <div>{{ utilization.currentUtilization }} out of {{ utilization.budget }} credits</div>
  <div class="utilization-bar">
    <mat-progress-bar color="accent" mode="determinate" [value]="utilization.currentUtilization*100/utilization.budget"></mat-progress-bar>
  </div>
  <div class="budget-cycle">Credits renew on {{ utilization.billingRestartDate | date:'longDate' }}</div>
</div>
